export const GentlewomanStore = {
  id: '5e3548c2d32cb12606a34fb8',
  name: 'gentlewoman'
}

export const GentlewomanBrand = 'Gentlewoman'
export const GentlelittlewomanBrand = 'Gentlelittlewoman'

export const GentlewomanBrands = [
  {
    id: 1,
    name: 'Gentlewoman'
  },
  {
    id: 2,
    name: 'Gentlelittlewoman'
  }
]
